import type { ReactNode } from "react";

const Check = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
);
const Cross = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-fg-tertiary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.4"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);
const Small = ({ children }: { children: ReactNode }) => (
  <span className="text-[9px] text-[var(--color-fg-tertiary)] whitespace-nowrap">{children}</span>
);

const headers = ["Harvey", "Lawhive", "Ascend / Keystone", "Opensity", "COSX"];

const rows: { label: string; cols: ReactNode[] }[] = [
  {
    label: "Autopilot",
    cols: [<Small>Copilot → Autopilot</Small>, <Small>Autopilot</Small>, <Cross />, <Cross />, <Check />],
  },
  {
    label: "Serves SME",
    cols: [<Cross />, <Check />, <Check />, <Cross />, <Check />],
  },
  {
    label: "Managed ops",
    cols: [<Cross />, <Small>Is the firm</Small>, <Check />, <Check />, <Check />],
  },
  {
    label: "Multi-vertical",
    cols: [<Cross />, <Cross />, <Cross />, <Check />, <Check />],
  },
  {
    label: "Scale",
    cols: [<Small>$190M ARR · $11B</Small>, <Small>$35M+ ARR · $116M raised</Small>, <Small>—</Small>, <Small>$400M revenue</Small>, <span className="text-[9px] italic text-[var(--color-fg-tertiary)]">Pre-revenue</span>],
  },
];

export function V3CompetitionSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[28px] font-light tracking-tight leading-tight mb-5 font-[family-name:var(--font-heading)]">
        Copilots sell the tool. Autopilots sell the work.<br />
        Only COSX is an autopilot MSO.
      </h2>

      <div className="overflow-x-auto mb-4">
        <table className="w-full border-collapse text-[11px]">
          <colgroup>
            <col style={{ width: "16%" }} />
            {headers.map((_, i) => (
              <col key={i} style={{ width: `${(100 - 16) / headers.length}%` }} />
            ))}
          </colgroup>
          <thead>
            <tr>
              <th className="py-2 px-2" />
              {headers.map((h, i) => (
                <th
                  key={h}
                  className={`py-2 px-2 text-center text-[10px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-wider ${
                    i === headers.length - 1
                      ? "bg-[var(--color-accent)] text-white rounded-t-sm"
                      : "text-[var(--color-fg-tertiary)]"
                  }`}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, ri) => (
              <tr key={r.label} className={ri < rows.length - 1 ? "border-b border-[var(--color-border)]" : ""}>
                <td className="py-2 px-2 text-[10px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] uppercase tracking-wider">
                  {r.label}
                </td>
                {r.cols.map((cell, ci) => (
                  <td
                    key={ci}
                    className={`py-2 px-2 text-center ${
                      ci === r.cols.length - 1 ? "bg-[var(--color-accent)]/5 border-x border-[var(--color-accent)]/20" : ""
                    } ${ci === r.cols.length - 1 && ri === rows.length - 1 ? "border-b border-[var(--color-accent)]/20 rounded-b-sm" : ""}`}
                  >
                    <div className="flex items-center justify-center">{cell}</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="space-y-1.5 mb-2">
        {[
          { name: "Harvey", text: "Faces the innovator's dilemma: selling the work means competing with its own customers." },
          { name: "Lawhive", text: "Competes with practitioners instead of empowering them." },
          { name: "Ascend / Keystone", text: "Proved MSO works but aren't AI-native." },
          { name: "Opensity", text: "Scales at $400M but isn't AI-native either." },
        ].map((c) => (
          <div key={c.name} className="flex items-baseline gap-8">
            <span className="shrink-0 w-[140px] text-[10px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em] text-[var(--color-accent)] whitespace-nowrap">
              {c.name}
            </span>
            <span className="text-[11px] text-[var(--color-fg-secondary)] leading-relaxed">{c.text}</span>
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] font-medium text-[var(--color-fg)]">
          COSX is the only AI-native autopilot that empowers practitioners instead of replacing them.
        </p>
      </div>
    </div>
  );
}
